import axios from 'axios'
import store from '@/store'

const apiClient = axios.create({
  baseURL: `/`,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.defaults.headers.get['Cache-Control'] = 'no-cache, no-store, must-revalidate'
apiClient.defaults.headers.get['Pragma'] = 'no-cache'
apiClient.defaults.headers.get['Expires'] = '0'

// リクエストごとに Vuex の token を参照
apiClient.interceptors.request.use(config => {
  if (config.method === 'get') {
    config.params = {
      ...(config.params || {}),
      _t: Date.now(), // キャッシュ防止
    }
  }
  const token = store.getters['auth/token']
  const lineUser = store.getters['auth/line']
  if (token) {
    config.headers['Authorization'] = `Bearer ${token.trim()}`
  }
  if (lineUser) {
    if (lineUser.id_token) {
      config.headers['X-Line-Id-Token'] = `${lineUser.id_token}`
    }
    if (lineUser.access_token) {
      config.headers['X-Line-Access-Token'] = `${lineUser.access_token}`
    }
  }
  return config
})

export default apiClient
